import { create } from 'zustand'

type ModalType =
	| 'deposit-primary'
	| 'manual-transfer'
	| 'moonpay-deposit'
	| 'withdraw'
	| 'transfer-prompt'
	| 'command-palette'
	| 'coming-soon'
	| 'auth'
	| 'bridge'
	| 'support'
	| 'pnl-calendar'

type TransferPromptData = {
	requiredAmount: number
	targetPlatform: 'polymarket' | 'kalshi'
	onSuccess?: () => void
}

type ModalState = {
	activeModal: ModalType | null
	transferPromptData: TransferPromptData | null
	openModal: (modal: ModalType) => void
	openTransferPrompt: (data: TransferPromptData) => void
	closeModal: () => void
}

export const useModalStore = create<ModalState>(set => ({
	activeModal: null,
	transferPromptData: null,
	openModal: modal => set({ activeModal: modal, transferPromptData: null }),
	openTransferPrompt: data => set({ activeModal: 'transfer-prompt', transferPromptData: data }),
	closeModal: () => set({ activeModal: null, transferPromptData: null }),
}))
